import * as Styling from '@/components/Styling';

export default {
  components: {
    ...Styling,
  },
};
